exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep ui-switch {\r\n    color: white;\r\n}\r\n::ng-deep .switch.switch-small{ border-radius: 4px; }\r\n::ng-deep .switch.switch-small small {\r\nwidth: 21px;\r\nheight: 25px;\r\nright: calc(100% - 21px);\r\nborder-radius: 4px;\r\nmargin-top: -3px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/publish-toggle-switch/publish-toggle-switch.component.css
// module id = ../../../../../src/app/shared/publish-toggle-switch/publish-toggle-switch.component.css
// module chunks = main